import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Mention from '@tiptap/extension-mention';
import { NodeViewWrapper, ReactNodeViewRenderer, ReactRenderer, } from '@tiptap/react';
import MentionSuggestionList from '../../suggestions/MentionSuggestionList';
import { createNodeAdapter } from '../../node';
import { assert } from '@varos/util-typescript';
// Sample mentionable items
const mentionableUsers = [
    { id: 'user-123', label: 'Alice Wonderland', icon: '👩‍💻' },
    { id: 'user-456', label: 'Bob The Builder', icon: '🛠️' },
    { id: 'page-789', label: 'Project Phoenix Plan', icon: '📄' },
    { id: 'task-abc', label: 'Deploy to Production', icon: '🚀' },
];
export function createMentionExtension(config) {
    const { Component, blockContext: { Provider: BlockContextProvider }, } = config;
    const TiptapMention = (props) => {
        const adapter = useMemo(() => createNodeAdapter(props), [props]);
        assert(props.node.attrs.item, 'item is required');
        const mentionData = props.node.attrs.item;
        const viewProps = {
            adapter,
            mention: mentionData,
        };
        return (_jsx(NodeViewWrapper, { as: "span", className: "tiptap-mention-node", style: { display: 'inline-block' }, children: _jsx(BlockContextProvider, { value: { adapter }, children: _jsx(Component, { ...viewProps }) }) }));
    };
    return Mention.configure({
        HTMLAttributes: {
            class: 'mention',
        },
        suggestion: {
            items: ({ query }) => {
                return mentionableUsers
                    .filter((item) => item.label.toLowerCase().startsWith(query.toLowerCase()))
                    .slice(0, 10);
            },
            render: () => {
                let component;
                return {
                    onStart: (props) => {
                        const targetRect = props.clientRect ? props.clientRect() : null;
                        if (!targetRect)
                            return; // Don't render if we can't get rect
                        component = new ReactRenderer(MentionSuggestionList, {
                            props: {
                                items: props.items,
                                command: props.command,
                                isOpen: true,
                                targetRect: targetRect,
                            },
                            editor: props.editor,
                        });
                    },
                    onUpdate: (props) => {
                        if (!component)
                            return;
                        const targetRect = props.clientRect ? props.clientRect() : null;
                        if (!targetRect) {
                            // If rect becomes unavailable, consider closing/hiding
                            component.updateProps({
                                isOpen: false,
                                items: [],
                                targetRect: null,
                                command: () => { },
                            });
                            return;
                        }
                        component.updateProps({
                            items: props.items,
                            command: props.command,
                            isOpen: true,
                            targetRect: targetRect,
                        });
                    },
                    onKeyDown: (props) => {
                        if (!component || !component.ref || !component.props.isOpen)
                            return false;
                        // The MentionSuggestionList useEffect for keydown should handle it
                        // We return false to allow Tiptap to also process the key if needed (e.g. for char input)
                        // unless MentionSuggestionList explicitly stops propagation for handled keys.
                        return false;
                    },
                    onExit: () => {
                        if (!component)
                            return;
                        component.destroy();
                    },
                };
            },
        },
    }).extend({
        group: 'inline',
        inline: true,
        atom: true,
        addAttributes() {
            return {
                ...this.parent?.(),
                item: {
                    default: null,
                    parseHTML: (element) => {
                        const itemData = element.getAttribute('data-item');
                        if (itemData) {
                            try {
                                return JSON.parse(itemData);
                            }
                            catch (e) {
                                console.error('Error parsing data-item for mention:', e);
                                return null;
                            }
                        }
                        return null;
                    },
                    renderHTML: (attributes) => {
                        if (attributes.item) {
                            try {
                                return {
                                    'data-item': JSON.stringify(attributes.item),
                                };
                            }
                            catch (e) {
                                console.error('Error stringifying item for mention:', e);
                                return {};
                            }
                        }
                        return {};
                    },
                },
                // id: {
                //     default: '',
                //     parseHTML: (element) => element.getAttribute('data-id') || '',
                //     renderHTML: (attributes) =>
                //         attributes.id ? { 'data-id': attributes.id } : {},
                // },
                // label: {
                //     default: '',
                //     parseHTML: (element) => element.getAttribute('data-label') || '',
                //     renderHTML: (attributes) =>
                //         attributes.label ? { 'data-label': attributes.label } : {},
                // },
                // icon: {
                //     default: null,
                //     parseHTML: (element) => element.getAttribute('data-icon'),
                //     renderHTML: (attributes) =>
                //         attributes.icon ? { 'data-icon': attributes.icon } : {},
                // },
                // href: {
                //     default: null,
                //     parseHTML: (element) =>
                //         element.getAttribute('href') || element.getAttribute('data-href'),
                //     renderHTML: (attributes) => {
                //         const htmlAttrs: Record<string, any> = {};
                //         if (attributes.href) {
                //             htmlAttrs['data-href'] = attributes.href;
                //         }
                //         return htmlAttrs;
                //     },
                // },
                // blockId: {
                //     default: null,
                //     parseHTML: (element) => element.getAttribute('data-block-id'),
                //     renderHTML: (attributes) =>
                //         attributes.blockId ? { 'data-block-id': attributes.blockId } : {},
                // },
                // tiptapNodeId: {
                //     default: null,
                //     parseHTML: (element) => element.getAttribute('data-tiptap-node-id'),
                //     renderHTML: (attributes) =>
                //         attributes.tiptapNodeId
                //             ? {
                //                   'data-tiptap-node-id': attributes.tiptapNodeId,
                //               }
                //             : {},
                // },
            };
        },
        addNodeView() {
            return ReactNodeViewRenderer(TiptapMention);
        },
    });
}
//# sourceMappingURL=mentionSpanExtension.js.map